<div class="card card-stretch h-100 rounded-0 context-menu">
    <div class="card-header p-3 d-flex justify-content-between border-bottom-0">
        <h5 class="card-title mb-0 font-weight-bolder">
            <img src="../../../../assets/common/images/Activities/BillableProject.svg" class="h-20px w-20px mr-2" />{{'ProjectsBillability' | localize}}
        </h5>

    </div>

    <div class="card-body p-1">
        <div *ngIf="!isLoaded  && isEmptyCheck">
            <div class="row ml-10 pt-10">
                <div class="col-md-11">
                    <ngx-shimmer-loading [width]="'100%'" [height]="'330px'"></ngx-shimmer-loading>

                </div>

            </div>
        </div>

        <div *ngIf="isLoaded  &&  isEmptyCheck">
            <div class="d-flex justify-content-center">
                <div class="d-flex flex-column mt-15">
                    <img src="../../../../assets/common/images/projects/EmptyProjects.svg" class="h-165px w-140px ml-4" />
                    <h6 class="text-muted text-center mt-4 ml-2">{{'NoDataFounds'|localize}}</h6>
                </div>
            </div>

        </div>
        <div *ngIf="isLoaded  &&  !isEmptyCheck" class="context-menu Chartdiplay">
            <div class="overflow-hidden diplayChart justify-content-center align-items-center ml-n4" [ngClass]="{'isArab':  isArabic }">
                <ngx-charts-pie-chart [view]="view" [scheme]="colorScheme" [results]="projectTypeCountDto" [legend]="false"
                                      [labels]="false" [doughnut]="true" [legendPosition]="'bottom'" [legendTitle]="''">
                </ngx-charts-pie-chart>
            </div>
            <div class="pt-3 d-flex justify-content-between">
                <div class="d-flex ml-3">
                    <div class="symbol symbol-success symbol-sm-20 mr-3">
                        <div class="symbol-label font-weight-boldest"></div>
                    </div>
                    <span [ngClass]="{'mr-5': isArabic == true}">
                        {{'Billable' | localize}}<span class="ml-1">
                            {{billableValue}}
                        </span>
                    </span>
                </div>

                <div class="d-flex mr-3">
                    <div class="symbol symbol-danger symbol-sm-20 mr-3  ">
                        <div class="symbol-label font-weight-boldest"></div>
                    </div>
                    <span [ngClass]="{'mr-3': isArabic == true}">
                        {{'NonBillable' | localize}}
                        <span class="ml-1"> {{NonbillableValue}}</span>
                    </span>
                </div>
            </div>


        </div>

    </div>
</div>

